var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourish2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 593.9299926757812 593.9299926757812",
    id: "Layer_2_1707940887485",
    width: 155,
    height: 155,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1_1707940887485 {\n        fill: #fff0d7;\n        stroke-width: 0px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_1707940887485"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.96,0l-72.4,223.57L0,295.97l223.56,72.4,72.4,223.57,72.4-223.57,223.56-72.4-223.56-72.4L295.96,0ZM299.49,287.46V33.74l62.07,191.66-62.07,62.07ZM292.44,287.46l-29.27-29.27-32.79-32.79,62.07-191.66v253.73ZM287.46,292.44H33.73l191.66-62.07,62.07,62.07ZM287.46,299.49l-62.07,62.07-191.66-62.07h253.73ZM263.17,333.74l29.27-29.27v253.73l-62.07-191.66,32.79-32.79ZM299.49,304.47l62.07,62.07-62.07,191.66v-253.73ZM304.47,299.49h253.73l-191.66,62.07-62.07-62.07ZM304.47,292.44l62.07-62.07,191.66,62.07h-253.73Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.7,191.58c-4.51-9.93-4.53-21.4-.04-31.33-9.93,4.49-21.37,4.48-31.31-.02,4.51,9.91,4.52,21.37.03,31.3,9.93-4.49,21.4-4.47,31.32.05Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1,160.29c-2.66-5.85-2.67-12.6-.02-18.45-5.85,2.65-12.58,2.64-18.43-.01,2.66,5.84,2.66,12.58.02,18.43,5.85-2.65,12.6-2.63,18.44.03Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.38,129c-1.5-3.31-1.51-7.13-.01-10.44-3.31,1.5-7.12,1.49-10.43,0,1.5,3.3,1.51,7.12.01,10.43,3.31-1.5,7.13-1.49,10.44.02Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.55,400.4c-9.93,4.49-21.4,4.47-31.32-.05,4.51,9.93,4.53,21.4.04,31.32,9.93-4.49,21.37-4.48,31.31.02-4.51-9.91-4.52-21.37-.03-31.3Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,431.67c-5.85,2.64-12.6,2.63-18.44-.03,2.66,5.85,2.67,12.6.02,18.45,5.85-2.65,12.58-2.64,18.43.01-2.66-5.84-2.66-12.58-.02-18.43Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.99,462.95c-3.31,1.5-7.13,1.49-10.44-.02,1.5,3.31,1.51,7.13.01,10.44,3.31-1.5,7.12-1.49,10.43,0-1.5-3.3-1.51-7.12,0-10.43Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.7,400.35c-9.91,4.51-21.37,4.52-31.3.03,4.49,9.93,4.47,21.4-.05,31.32,9.93-4.51,21.4-4.53,31.32-.04-4.49-9.93-4.48-21.37.02-31.31Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.67,431.66c2.64,5.85,2.63,12.6-.03,18.44,5.85-2.66,12.6-2.67,18.45-.02-2.64-5.85-2.64-12.58.01-18.43-5.84,2.66-12.58,2.66-18.43.02Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.95,462.94c1.5,3.31,1.49,7.13-.02,10.44,3.31-1.5,7.13-1.51,10.44-.01-1.5-3.31-1.49-7.12,0-10.43-3.3,1.5-7.12,1.51-10.43.01Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,160.27c4.49,9.93,4.48,21.37-.02,31.31,9.91-4.51,21.37-4.52,31.3-.03-4.49-9.93-4.47-21.4.05-31.32-9.93,4.51-21.4,4.53-31.32.04Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.26,160.27c-2.65-5.85-2.63-12.6.03-18.44-5.85,2.66-12.6,2.67-18.45.02,2.65,5.85,2.64,12.58-.01,18.43,5.84-2.66,12.58-2.66,18.43-.02Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.56,118.57c1.5,3.31,1.49,7.12,0,10.43,3.3-1.5,7.12-1.51,10.43,0-1.5-3.31-1.49-7.13.02-10.44-3.31,1.5-7.13,1.51-10.44.01Z",
    className: "cls-1_1707940887485",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(85, 45, 67)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourish2);
export default __webpack_public_path__ + "static/media/flourish2.f3862660cdd8ff6f18b2e73bb1a3a332.svg";
export { ForwardRef as ReactComponent };